import React, { FC } from 'react'

import './placeholder.css'

interface Props {
  size?: number
}

const Item = ({ className = '' }) => {
  return (
    <div className={`placeholder__wrapper ${className}`}>
      <div className="placeholder__box placeholder__icon" />

      <div className="placeholder__content">
        <div className="placeholder__box placeholder__title" />
        <div className="placeholder__box placeholder__subtitle" />
      </div>
      <div className="placeholder__box placeholder__price" />
    </div>
  )
}

const Placeholder: FC<Props> = ({ size = 4 }) => {
  return (
    <div className="">
      <div className="placeholder__box placeholder__heading" />
      {[...Array(size)].map((_, idx) => (
        <Item key={`placeholder-${idx}`} className={`animation-delay-${100 * idx}`} />
      ))}
    </div>
  )
}

export default Placeholder
